import { useSelect } from '@refinedev/antd';
import { ICourse } from 'interfaces/courses';
import { IGraduateCourse } from 'interfaces/graduate_courses';

export const useCorporateCourseOptions = (
  selectedEnrollmentType?: string
) => {
  const isCoursesEnrollment = selectedEnrollmentType === 'Courses::Enrollment';
  const isGraduateEnrollment =
    selectedEnrollmentType === 'Graduate::Courses::Enrollment';

  const { selectProps: freeCourseOptions } = useSelect<ICourse>({
    resource: 'courses',
    optionLabel: 'name',
    optionValue: 'id',
    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],
    pagination: {
      mode: 'server',
      pageSize: 100
    },
    queryOptions: {
      enabled: isCoursesEnrollment
    }
  });

  const { selectProps: graduateCourseOptions } = useSelect<IGraduateCourse>({
    resource: 'graduate_courses',
    optionLabel: 'name',
    optionValue: 'id',
    onSearch: value => [
      {
        field: 'filter[name]',
        operator: 'eq',
        value
      }
    ],
    pagination: {
      mode: 'server',
      pageSize: 100
    },
    queryOptions: {
      enabled: isGraduateEnrollment
    }
  });

  const courseOptions = isCoursesEnrollment
    ? freeCourseOptions
    : isGraduateEnrollment
      ? graduateCourseOptions
      : undefined;

  return {
    isCoursesEnrollment,
    isGraduateEnrollment,
    courseOptions
  };
};
